import { useSelector } from 'react-redux';
import { cobrandImages } from '../config/cobrandImages';
import { selectClientCobrand } from '../cobrandSlice';
import { CobrandIdentifier, CobrandMap } from '../types';

export const useCobrandImages = () => {
  // Use Redux clientCobrand which works for both hostname and path-based routing
  const clientCobrand = useSelector(selectClientCobrand);

  // Fallback to Wellframe if Redux hasn't been populated yet
  const cobrand = clientCobrand ?? CobrandMap[CobrandIdentifier.WELLFRAME];

  return { ...cobrandImages[cobrand.id] };
};
